module.exports = __webpack_public_path__ + "static/service-icon2-27df06e5a41c11d8608c32f04f7bb2c2.png";